import { render } from "./TelaAtualizarSenha.vue?vue&type=template&id=e96afc7e&scoped=true"
import script from "./TelaAtualizarSenha.vue?vue&type=script&lang=js"
export * from "./TelaAtualizarSenha.vue?vue&type=script&lang=js"

import "./TelaAtualizarSenha.vue?vue&type=style&index=0&id=e96afc7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e96afc7e"]])

export default __exports__